import React, { useContext } from "react";
import { IconButton, Select } from "uxp/components";
import { QueryBuilderContext } from "@query-builder/QueryBuilderContext";
import './SortEditor.scss';
export const SortEditor = props => {
    const { conditions, onChange, fields } = props;
    const context = useContext(QueryBuilderContext);
    const $L = (key) => context.uxpContext.$L(key);
    function addCondition() {
        const newCondition = {
            field: '',
            descending: false
        };
        onChange([...conditions, newCondition]);
    }
    function updateCondition(index, field, value) {
        const updatedConditions = conditions.map((condition, i) => {
            if (i === index) {
                return Object.assign(Object.assign({}, condition), { [field]: value });
            }
            return condition;
        });
        onChange(updatedConditions);
    }
    function removeCondition(index) {
        const updatedConditions = conditions.filter((_, i) => i !== index);
        onChange(updatedConditions);
    }
    return React.createElement("div", { className: "query-editor-sort-editor-container-a594487f" },
        React.createElement("div", { className: "query-editor-sort-conditions-container-a594487f" }, conditions === null || conditions === void 0 ? void 0 : conditions.map((c, i) => {
            return React.createElement("div", { className: "query-editor-sort-condition-row-a594487f", key: i },
                React.createElement("div", { className: "query-editor-sort-condition-content-a594487f" },
                    React.createElement("div", { className: "query-editor-sort-condition-value-a594487f" },
                        React.createElement(Select, { selected: (c === null || c === void 0 ? void 0 : c.field) || '', onChange: v => updateCondition(i, 'field', v), options: fields || [], valueField: 'name', labelField: 'name', className: "query-editor-input-a594487f", showEndOfContent: false })),
                    React.createElement("div", { className: "query-editor-sort-condition-value-a594487f" },
                        React.createElement(Select, { selected: (c === null || c === void 0 ? void 0 : c.descending) ? 'desc' : 'asc', onChange: v => updateCondition(i, 'descending', v === 'desc'), options: [{
                                    label: $L('lqe.sort.ascending'),
                                    value: 'asc'
                                }, {
                                    label: $L('lqe.sort.descending'),
                                    value: 'desc'
                                }], className: "query-editor-input-a594487f", showEndOfContent: false }))),
                React.createElement("div", { className: "query-editor-sort-delete-wrap-a594487f" },
                    React.createElement(IconButton, { type: 'delete', variant: 'danger', onClick: () => removeCondition(i) })));
        })),
        React.createElement("div", { className: "query-editor-sort-condition-add-a594487f", onClick: addCondition }, $L('lqe.sort.add')));
};
export function validateSortConditions(conditions) {
    if (!conditions || (conditions === null || conditions === void 0 ? void 0 : conditions.length) === 0) {
        return {
            isValid: false,
            error: 'lqe.sort.error-no-conditions'
        };
    }
    const uniqueAttributes = new Set();
    for (const condition of conditions) {
        if (!condition.field) {
            return {
                isValid: false,
                error: 'lqe.sort.error-incomplete'
            };
        }
        uniqueAttributes.add(condition.field);
    }
    return {
        isValid: true,
        error: null,
        uniqueAttributes: Array.from(uniqueAttributes)
    };
}
